import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'gatsby'
import { StaticQuery, graphql } from "gatsby"
import { Scrollbars } from 'react-custom-scrollbars-2';
import { siteMetadata, pages } from '../../site-config'
const moment = require('moment')

class Navigation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            navActive: false
        }
        this.navToggle = this.navToggle.bind(this)
    }

    navToggle() {
        this.setState({
            navActive: !this.state.navActive
        })
    }

    navigationOutsightSection = (data) => {
        if (data.allPrismicInsightArticle.nodes) {
            return (
                <>
                    <div className="c-navbar__links-title-container">
                        <div className="c-navbar__links-title">Insights</div>
                        <a className="c-navbar__links-title-link" href={`/${data.allPrismicInsightArticle.nodes[0].url.split('/')[1]}/`}>Discover More <svg fill="none" viewBox="0 0 6 8"><path d="m1 1 3 3-3 3" stroke="#2ADAC6" strokeWidth="2"/></svg></a>
                    </div>
                    <div className="row">
                        {data.allPrismicInsightArticle.nodes.map((navItem, i) => {
                            return (
                                <div key={navItem.url} className="c-navbar__insight">
                                    <a className="c-navbar__insight-link" href={navItem.url}>
                                        <div className="c-navbar__insight-media-container">
                                            <div className="c-navbar__insight-media-wrapper">
                                                <img src={navItem.data.listing_image.url ? `${navItem.data.listing_image.url}&w=250` : "https://picsum.photos/320/180"} alt={navItem.data.listing_image.alt ? navItem.data.listing_image.alt : navItem.data.title.text}
                                                    className="c-navbar__insight-media" loading="lazy"/>
                                            </div>
                                            {navItem.tags.length ? <div className="c-navbar__insight-category">{navItem.tags[0]}</div> : null}
                                        </div>
                                        <div className="c-navbar__insight-title">{navItem.data.title.text}</div>
                                            {navItem.data.date ?
                                                <div className="c-navbar__insight-date">
                                                    {moment(navItem.data.date).format("Do MMMM YYYY")}
                                                </div> : null}
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </>
            )
        } else {
            return null
        }
    }

    navigationCustomerStoriesSection = (data) => {
        if (data.prismicHome.data.customer_story_link) {
            const storyDoc = data.prismicHome.data.customer_story_link.document

            if (storyDoc.url !== null) {
                return (
                    <>
                        <div className="c-navbar__links-title-container">
                            <div className="c-navbar__links-title">Customer Stories</div>
                            <a className="c-navbar__links-title-link" href={`/${storyDoc.url.split('/')[1]}/`}>Discover More <svg fill="none" viewBox="0 0 6 8"><path d="m1 1 3 3-3 3" stroke="#2ADAC6" strokeWidth="2"/></svg></a>
                        </div>
                        <div className="row">
                            <div className="c-navbar__story">
                                <a className="c-navbar__story-link" href={storyDoc.url}>
                                    <div className="c-navbar__story-media-container">
                                        <div className="c-navbar__story-media-wrapper">
                                            <img src={storyDoc.data.listing_image.url ? `${storyDoc.data.listing_image.url}&w=500` : "https://picsum.photos/320/180"} alt="" className="c-navbar__story-media" loading="lazy"/>
                                        </div>
                                        {storyDoc.tags.length ? <div className="c-navbar__story-category">{storyDoc.tags[0]}</div> : null}
                                    </div>
                                    <div className="c-navbar__story-title">{storyDoc.data.title.text}</div>
                                </a>
                            </div>
                        </div>
                    </>
                )
            }
        } else {
            return null
        }
    }

    navigation = (data) => {
        return (
            <nav className={this.state.navActive ? 'c-navbar is-nav-open' : 'c-navbar'}>
                <div className="container">
                    <div className="row">
                        <div className="c-navbar__container">
                            <Link to="/" className="c-navbar__brand">
                                <svg viewBox="0 0 117 59">
                                    <path d="M24.134 15.332V5.868h1.256v9.312c0 3.163 1.02 4.67 3.43 4.67 1.794 0 3.09-.955 4.853-3.075V5.868h1.256v14.748h-1.08l-.126-2.497h-.06c-1.464 1.73-3.009 2.856-5.048 2.856-3.06 0-4.481-1.843-4.481-5.653M40.688 16.593V7.004H38.37V5.993l2.348-.122.156-4.885h1.08v4.882h4.327v1.136h-4.317v9.679c0 1.905.464 3.196 2.534 3.196a4.336 4.336 0 0 0 1.886-.46l.402.89a5.417 5.417 0 0 1-2.441.666c-2.843 0-3.657-1.773-3.657-4.382ZM47.72 18.927l.68-.799c1.237 1.044 2.565 1.748 4.79 1.748 2.379 0 3.617-1.383 3.617-2.949 0-1.875-1.916-2.704-3.647-3.319-2.288-.799-4.636-1.69-4.636-4.21 0-2.087 1.668-3.9 4.772-3.9a6.606 6.606 0 0 1 4.202 1.536l-.736.801a5.56 5.56 0 0 0-3.554-1.228c-2.348 0-3.398 1.35-3.398 2.734 0 1.688 1.607 2.335 3.398 3.011 2.348.89 4.883 1.628 4.883 4.495 0 2.212-1.791 4.148-4.976 4.148-2.313-.02-4.139-.81-5.395-2.068ZM61.712 5.868h1.078l.153 2.304h.063c1.329-1.498 3.029-2.671 4.697-2.671 2.378 0 3.553 1.196 4.078 3.041 1.706-1.875 3.343-3.049 5.044-3.049 2.936 0 4.42 1.843 4.42 5.653v9.47h-1.268v-9.31c0-3.134-1.05-4.67-3.368-4.67-1.392 0-2.843.952-4.481 2.827v11.152H70.86v-9.309c0-3.134-1.083-4.67-3.368-4.67-1.362 0-2.844.952-4.521 2.827v11.152h-1.256l-.003-14.747ZM85.324 16.96c0-3.286 2.996-4.824 9.609-5.561.033-2.305-.585-4.762-3.516-4.762-2.042 0-3.768.984-4.76 1.69l-.587-.923c1.02-.767 3.059-1.903 5.47-1.903 3.486-.008 4.654 2.55 4.654 5.653v9.462H95.11l-.153-1.936h-.063c-1.507 1.229-3.338 2.305-5.274 2.305-2.318 0-4.295-1.228-4.295-4.025h-.002Zm9.614.52v-5.097c-6.211.737-8.313 2.12-8.313 4.517 0 2.15 1.484 2.979 3.215 2.979 1.73 0 3.214-.83 5.098-2.397M101.177 5.868h1.08l.156 2.767h.06c.99-1.813 2.444-3.141 4.204-3.141a2.927 2.927 0 0 1 1.452.307l-.339 1.106a3.754 3.754 0 0 0-1.268-.185c-1.359 0-2.934 1.014-4.079 3.81v10.084h-1.256l-.01-14.748ZM110.912 16.593V7.004h-2.318V5.993l2.348-.122.153-4.885h1.083v4.882h4.327v1.136h-4.327v9.679c0 1.905.464 3.196 2.534 3.196a4.333 4.333 0 0 0 1.886-.46l.402.89a5.417 5.417 0 0 1-2.441.666c-2.846 0-3.647-1.783-3.647-4.392M4.82 32.576H0v20.001h4.82v-20ZM8.808 37.308h3.893l.342 1.895h.123c1.256-1.23 2.813-2.274 4.913-2.274 3.337 0 4.772 2.364 4.772 6.175v9.464h-4.803v-8.84c0-2.12-.557-2.764-1.793-2.764-1.08 0-1.73.522-2.687 1.383v10.238H8.796l.012-15.277ZM25 50.642l2.01-2.674a6.455 6.455 0 0 0 4.018 1.476c1.299 0 1.824-.462 1.824-1.199 0-.921-1.299-1.32-2.936-1.935-2.195-.799-4.05-2.182-4.05-4.547 0-2.89 2.35-4.824 5.933-4.824a8.61 8.61 0 0 1 5.503 1.935l-2.04 2.674a5.61 5.61 0 0 0-3.307-1.096c-1.113 0-1.637.43-1.637 1.106 0 .8.863 1.166 2.812 1.78 2.349.75 4.202 2.12 4.202 4.64 0 2.797-2.225 4.98-6.397 4.98-2.04 0-4.387-.8-5.935-2.306M39.528 32.711c0-1.475 1.112-2.427 2.687-2.427 1.575 0 2.69.93 2.69 2.427 0 1.498-1.113 2.457-2.69 2.457s-2.688-.951-2.688-2.457Zm.309 4.61h4.759v15.27h-4.76V37.32ZM47.313 55.16c0-1.261.754-2.275 2.165-3.011v-.123a2.982 2.982 0 0 1-1.391-2.612c0-1.076.71-2.182 1.7-2.889v-.122a4.83 4.83 0 0 1-1.516-1.716 4.797 4.797 0 0 1-.55-2.217c0-3.718 3.091-5.531 6.429-5.531a7.455 7.455 0 0 1 2.411.37h5.654v3.44H59.8c.305.578.463 1.221.462 1.873 0 3.566-2.72 5.132-6.118 5.132a7.097 7.097 0 0 1-1.824-.277 1.23 1.23 0 0 0-.502 1.046c0 .749.618 1.076 2.26 1.076h2.442c3.802 0 5.935 1.136 5.935 3.9 0 3.227-3.368 5.494-8.716 5.494-3.553 0-6.43-1.106-6.43-3.84l.003.007Zm10.57-.84c0-.92-.805-1.105-2.261-1.105H54.14a8.528 8.528 0 0 1-2.165-.183c-.503.43-.754.86-.754 1.351 0 1.106 1.299 1.658 3.265 1.658 1.967 0 3.371-.749 3.371-1.72h.025Zm-1.82-11.858c0-1.568-.803-2.367-1.946-2.367-1.143 0-1.946.8-1.946 2.367 0 1.569.834 2.428 1.946 2.428 1.113 0 1.947-.83 1.947-2.428ZM64.59 31.1h4.76v5.162l-.218 2.734c1.145-1.014 2.627-2.057 4.729-2.057 3.338 0 4.76 2.364 4.76 6.175v9.464h-4.78v-8.85c0-2.12-.558-2.764-1.793-2.764-1.083 0-1.731.522-2.688 1.383v10.238h-4.77V31.101ZM82.7 46.924v-5.9h-2.078v-3.569l2.349-.152.555-4.672h3.955v4.672h3.617v3.715h-3.617v5.838c0 1.72.804 2.368 1.95 2.368.482.01.963-.063 1.42-.215l.742 3.319a9.752 9.752 0 0 1-3.491.614c-3.833 0-5.41-2.427-5.41-6.023M10.549 1.194a9.392 9.392 0 0 1 5.198 1.565 9.311 9.311 0 0 1 3.447 4.173 9.25 9.25 0 0 1 .533 5.373 9.282 9.282 0 0 1-2.56 4.763 9.37 9.37 0 0 1-4.79 2.545 9.404 9.404 0 0 1-5.405-.53 9.342 9.342 0 0 1-4.197-3.427A9.26 9.26 0 0 1 1.2 10.488 9.284 9.284 0 0 1 3.944 3.92a9.393 9.393 0 0 1 6.605-2.727Zm0-1.194c-2.087 0-4.126.615-5.86 1.767A10.5 10.5 0 0 0 .802 6.474a10.431 10.431 0 0 0-.6 6.06 10.469 10.469 0 0 0 2.887 5.37 10.568 10.568 0 0 0 5.4 2.87c2.047.404 4.168.197 6.095-.597a10.536 10.536 0 0 0 4.735-3.863 10.444 10.444 0 0 0-1.312-13.242A10.58 10.58 0 0 0 10.548 0"/>
                                </svg>
                            </Link>
                            <div className="c-navbar__menu-container">
                                <Link to={pages.careers} className="c-navbar__menu-contact c-btn c-btn--text">Careers</Link>
                                <Link to={pages.contact} className="c-navbar__menu-contact c-btn c-btn--text">
                                    Contact Our Team
                                </Link>

                                <button
                                    className="c-navbar__menu"
                                    type="button"
                                    onClick={this.navToggle}>
                                    <span>
                                        <span className="u-visually-hide">Menu</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-navbar__links">
                    <Scrollbars universal autoHide>
                        <div className="container">
                            <div className="row">
                                <div className="c-navbar__links-col">
                                    <div className="c-navbar__links-title-container">
                                        <div className="c-navbar__links-title">Services</div>
                                    </div>
                                    <ul className="c-navbar__list">
                                        {data.prismicHome.data.service_links ? data.prismicHome.data.service_links.map((navItem, i) => {
                                            return (
                                                navItem.service_links_name.text && navItem.service_links_link.url && (navItem.service_links_link.type === "service" || navItem.service_links_link.type === null) ?
                                                    <li key={`${navItem.service_links_link.url}-${i}`} className="c-navbar__list-item">
                                                        <a className="c-navbar__list-link" href={navItem.service_links_link.url}>{navItem.service_links_name.text}</a>
                                                    </li> : null
                                            )
                                        }) : null}
                                    </ul>
                                </div>
                                <div className="c-navbar__links-col">
                                    <div className="c-navbar__links-title-container">
                                        <div className="c-navbar__links-title">Solutions</div>
                                    </div>
                                    <ul className="c-navbar__list">
                                        {data.prismicHome.data.solution_links ? data.prismicHome.data.solution_links.map((navItem, i) => {
                                            return (
                                                navItem.solution_links_name.text && navItem.solution_links_link.url && (navItem.solution_links_link.type === "solution" || navItem.solution_links_link.type === null) ?
                                                    <li key={`${navItem.solution_links_link.url}-${i}`} className="c-navbar__list-item">
                                                        <a className="c-navbar__list-link" href={navItem.solution_links_link.url}>{navItem.solution_links_name.text}</a>
                                                    </li> : null
                                            )
                                        }) : null}
                                    </ul>

                                    <div className="c-navbar__methodology">
                                        <div className="c-navbar__links-title-container">
                                            <div className="c-navbar__links-title">Methodology</div>
                                        </div>
                                        <ul className="c-navbar__list">
                                            <li className="c-navbar__list-item">
                                                <Link className="c-navbar__list-link" to={"/our-approach"}>Our approach</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="c-navbar__links-col">
                                    {this.navigationOutsightSection(data)}
                                    {this.navigationCustomerStoriesSection(data)}
                                </div>
                                <div className="c-navbar__contact-info">
                                    {siteMetadata.address}<br/>
                                    <a href={`tel:${siteMetadata.telephoneNo.replace("(", "").replace(")", "").replace(" ", "")}`}>{siteMetadata.telephoneNo}</a><br/>
                                    <a href={`mailto:${siteMetadata.email.contact}`} target="_blank" rel="noreferrer">{siteMetadata.email.contact}</a>
                                </div>
                            </div>
                        </div>
                    </Scrollbars>
                </div>
            </nav>
        )
    }

    render() {
        return (
            <>
                <Helmet
                    bodyAttributes={{
                        class: this.state.navActive ? 'is-nav-open' : ''
                    }}
                />
                <StaticQuery
                    query={graphql`
                        query {
                            prismicHome {
                                data {
                                    service_links {
                                            service_links_name {
                                            text
                                        }
                                        service_links_link {
                                            url
                                            type
                                        }
                                    }
                                    solution_links {
                                        solution_links_link {
                                            url
                                            type
                                        }
                                        solution_links_name {
                                            text
                                        }
                                    }
                                    customer_story_link {
                                      document {
                                        ... on PrismicCustomerStory {
                                          data {
                                            listing_image {
                                              url
                                            }
                                            title {
                                              text
                                            }
                                          }
                                          url
                                          tags
                                        }
                                      }
                                    }
                                }
                            }
                            allPrismicInsightArticle(sort: {fields: data___date, order: DESC}, limit: 2) {
                              nodes {
                                data {
                                  summary {
                                    text
                                  }
                                  title {
                                    text
                                  }
                                  date
                                  listing_image {
                                    alt
                                    url
                                  }
                                }
                                tags
                                url
                              }
                            }
                        }
                    `}
                render={data => this.navigation(data)} />
            </>
        )
    }
}

export default Navigation